import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
@Injectable({
  providedIn: 'root'
})
export class InteractionsService {
  constructor (private readonly httpClient: HttpClient) { }
  private readonly url: string = environment.url

  getInteractions (territoryId: string): Observable<any> {
    let params = new HttpParams()
    params = params.set('territoryId', territoryId)

    return this.httpClient.get(`${this.url}/interactions/removed`, { params: params })
  }
}
